module.exports = __webpack_public_path__ + "img/bg-glasses.9d43fa24.jpg";